import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { Directive, ElementRef, HostListener, input, OnDestroy, ViewContainerRef } from '@angular/core';
import { CategoryTooltipData } from '@core/models';
import { CategoriesTooltipComponent } from '../../components/categories-tooltip/categories-tooltip.component';

@Directive({
  selector: '[appCategoriesToolTip]',
  standalone: false,
})
export class CategoriesToolTipDirective implements OnDestroy {
  appCategoriesToolTip = input<CategoryTooltipData | null>(null);

  private overlayRef: OverlayRef | null = null;

  constructor(
    private elementRef: ElementRef,
    private overlay: Overlay,
    private viewContainerRef: ViewContainerRef,
  ) {}

  @HostListener('mouseenter')
  showTooltip() {
    if (!this.appCategoriesToolTip() || this.overlayRef) return;

    const positionStrategy = this.overlay
      .position()
      .flexibleConnectedTo(this.elementRef)
      .withPositions([
        { originX: 'center', originY: 'bottom', overlayX: 'center', overlayY: 'top', offsetY: 15 },
        { originX: 'center', originY: 'top', overlayX: 'center', overlayY: 'bottom', offsetY: -15 },
      ]);

    this.overlayRef = this.overlay.create({
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.close(),
      hasBackdrop: false,
    });

    const componentRef = this.viewContainerRef.createComponent(CategoriesTooltipComponent);
    componentRef.setInput('data', this.appCategoriesToolTip());

    const portal = new TemplatePortal(componentRef.instance.tooltipTemplate(), this.viewContainerRef);

    this.overlayRef.attach(portal);
  }

  @HostListener('mouseleave')
  hideTooltip() {
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }

  ngOnDestroy() {
    this.hideTooltip();
  }
}
